import { View, StyleSheet, Text } from '@react-pdf/renderer';

const pdfStyles = StyleSheet.create({
  wrapper: {
    marginTop: '10px',
    display: 'flex',
    width: '100%',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    marginBottom: 10,
    flexDirection: 'column',
  },
  removeWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  informedIndividualsHeader: {
    marginTop: '12px',
    marginBottom: '12px',
  },
  removeIndividual: {
    fontFamily: 'Schibsted Grotesk',
    fontSize: '16px',
    fontWeight: 400,
    color: '#F83B3B',
    fontStyle: 'italic',
    display: 'flex',
    alignItems: 'center',
  },
  row: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'flex-start',
  },
  columnText: {
    fontWeight: 500,
    textAlign: 'left',
    fontSize: '12px',
    wordWrap: 'break-word',
    color: '#878787',
    fontFamily: 'Schibsted Grotesk',
  },
  rowTextWrapper: {
    width: '25%',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingRight: '5px',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  textTitle: {
    fontWeight: 500,
    fontSize: '12px',
    color: '#181818',
    fontFamily: 'Schibsted Grotesk',
  },
  nameRow: {
    width: '15%',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  rowText: {
    fontWeight: 500,
    fontSize: '12px',
    textAlign: 'left',
    color: '#4F4F4F',
    maxWidth: '100px',
    wordWrap: 'break-word',
    fontFamily: 'Schibsted Grotesk',
  },
  firstColumn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: '4px',
    borderBottomWidth: 1,
    borderBottomColor: '#D6D6D6',
  },
  column: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  columnView: {
    width: '25%',
  },
  firstColumnView: {
    width: '10%',
  },
});

type ItemType = {
  id: number;
  report: string;
  name: string;
  associatedDepartment: string;
  notificationReason: string;
  dateInformed: string;
};

const InformedIndividualsSectionPDF = ({
  items = [],
  hasInformedIndividuals = false,
}: {
  items: Array<ItemType>;
  hasInformedIndividuals: boolean;
}) => {
  return hasInformedIndividuals && items.length > 0 ? (
    <View style={pdfStyles.wrapper}>
      <View style={pdfStyles.informedIndividualsHeader}>
        <Text style={pdfStyles.textTitle}>Informed Individuals</Text>
      </View>
      <View style={pdfStyles.row}>
        <View style={[pdfStyles.firstColumn]}>
          <View style={[pdfStyles.columnView, { width: '15%' }]}>
            <Text style={pdfStyles.columnText}>Name</Text>
          </View>
          <View style={[pdfStyles.firstColumnView, { width: '35%' }]}>
            <Text style={pdfStyles.columnText}>Associated Department</Text>
          </View>
          <View style={[pdfStyles.firstColumnView, { width: '25%' }]}>
            <Text style={pdfStyles.columnText}>Notification Reason</Text>
          </View>
          <View style={[pdfStyles.firstColumnView, { width: '25%' }]}>
            <Text style={pdfStyles.columnText}>{'Date Informed'}</Text>
          </View>
        </View>
        <View style={pdfStyles.row}>
          {items.map((i, k) => {
            return (
              <View style={pdfStyles.column} key={`tr-${k}`}>
                <View style={[pdfStyles.rowTextWrapper, { width: '15%' }]}>
                  <Text style={[pdfStyles.rowText]}>{i.name}</Text>
                </View>
                <View style={[pdfStyles.rowTextWrapper, { width: '35%' }]}>
                  <Text style={pdfStyles.rowText}>
                    {i.associatedDepartment}
                  </Text>
                </View>
                <View wrap style={[pdfStyles.rowTextWrapper, { width: '25%' }]}>
                  <Text style={pdfStyles.rowText}>{i.notificationReason}</Text>
                </View>
                <View style={[pdfStyles.rowTextWrapper, { width: '25%' }]}>
                  <Text style={pdfStyles.rowText}>{i.dateInformed}</Text>
                </View>
              </View>
            );
          })}
        </View>
      </View>
    </View>
  ) : null;
};

export default InformedIndividualsSectionPDF;
